/* eslint-disable no-underscore-dangle */
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Multitenant } from '../../../services/multitenant.provider';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';

@Component({
  selector: 'app-partager-button',
  templateUrl: './partager-button.component.html',
  styleUrls: ['partager-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartagerButtonComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() image: string;
  @Input() include: Array<string>;

  public shareVisible = false;
  public right = false;
  private _url: string;

  constructor(
    private multiTenant: Multitenant,
    private ga: GaEventTrackerProvider,
    private elementRef: ElementRef,
    private router: Router
  ) { }

  get url() {
    return this._url;
  }

  @Input()
  set url(value) {
    this._url = `${window.location.protocol}//${window.location.hostname}${value}`;
  }

  @HostListener('document:click', ['$event']) clickOutside(event) {
    if (this.shareVisible && !this.elementRef.nativeElement.contains(event.target)) {
      this.close();
    }
  }

  @HostListener('click') share() {
    if (this.ga) {
      this.ga.trackEvent(this.multiTenant.getDomainClass(), 'Clic','Partager un article', null);
    }
    this.toggleShare();
  }


  ngOnInit(): void {
    const url = this.router.routerState.snapshot.url.split('/');
    if (url && (url[1] === 'article' || url[1] === 'exposes-detail')) {
      this.right = true;
    }
  }

  close() {
    this.shareVisible = false;
  }

  toggleShare() {
    this.shareVisible = !this.shareVisible;
  }
}
